import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UploadStatus = 'uploading' | 'done' | 'error';

export interface IUploadItem {
  tempId: string;
  fileName: string;
  progress: number;
  status: UploadStatus;
  projectId: number;
  folderId: string;
  mimeType: string;
  size: number;
}

export interface IFileCabinetUploadSlice {
  uploads: Record<string, IUploadItem>;
}

const initialState: IFileCabinetUploadSlice = {
  uploads: {},
};

export const fileCabinetUploadSlice = createSlice({
  name: 'file-cabinet-upload',
  initialState,
  reducers: {
    addUpload: (state, action: PayloadAction<IUploadItem>) => {
      state.uploads[action.payload.tempId] = action.payload;
    },

    updateUploadProgress: (state, action: PayloadAction<{ tempId: string; progress: number }>) => {
      const upload = state.uploads[action.payload.tempId];
      if (upload) {
        upload.progress = action.payload.progress;
      }
    },

    finishUpload: (state, action: PayloadAction<{ tempId: string }>) => {
      const upload = state.uploads[action.payload.tempId];
      if (upload) {
        upload.status = 'done';
        upload.progress = 100;
      }
    },

    failUpload: (state, action: PayloadAction<{ tempId: string }>) => {
      const upload = state.uploads[action.payload.tempId];
      if (upload) {
        upload.status = 'error';
      }
    },

    removeUpload: (state, action: PayloadAction<{ tempId: string }>) => {
      delete state.uploads[action.payload.tempId];
    },
  },
});

export const { addUpload, updateUploadProgress, finishUpload, failUpload, removeUpload } =
  fileCabinetUploadSlice.actions;

export default fileCabinetUploadSlice.reducer;
